'use strict';
var IS_NODE = require('../internals/engine-is-node');

module.exports = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) { /* empty */ }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/try-node-require.js
// module id = 230
// module chunks = 0